import { useState, useEffect, useRef } from 'react';

export default function StickyNote({ pos, children, draggable=false }) {
    const [position, setPosition] = useState(pos);
    const [color, setColor] = useState("");
    const draggingRef = useRef(false);
    const offsetRef = useRef({ x: 0, y: 0 });
    const noteRef = useRef(null);

    function getRandomNeonColor() {
        let r = Math.floor(Math.random() * 128) + 64;
        let g = Math.floor(Math.random() * 128) + 64;
        let b = Math.floor(Math.random() * 128) + 64;
        if (r < 128 && g < 128 && b < 128) {
            if (Math.random() < 0.66) r = Math.floor(Math.random() * 192) + 64;
            else if (Math.random() < 0.5) g = Math.floor(Math.random() * 192) + 64;
            else b = Math.floor(Math.random() * 192) + 64;
        }
        const toHex = (c) => c.toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }

    useEffect(() => {
        setColor(getRandomNeonColor());
    }, []);

    const handleMouseDown = (e) => {
        if (!draggable) return;
        if (!e.target.closest(".stickyNoteTop")) return;
        draggingRef.current = true;
        const rect = noteRef.current.getBoundingClientRect();
        offsetRef.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        
        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);
    };
    
    const handleMouseMove = (e) => {
        if (!draggingRef.current) return;
        setPosition({
            x: e.clientX - offsetRef.current.x + 100,
            y: e.clientY - offsetRef.current.y
        });
        window.getSelection().removeAllRanges();
    };

    const handleMouseUp = () => {
        draggingRef.current = false;
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
    };

    const style = {
        position: 'absolute',
        backgroundColor: color,
        left: position.x,
        top: position.y,
    };

    return (
        <div ref={noteRef} className={draggable ? 'draggable stickyNote' : "stickyNote"} style={style} >
            <div className="stickyNoteTop" onMouseDown={handleMouseDown}>{draggable ? "Drag me!" : ""}</div>
            <div className="stickyNoteTex"></div>
            <div className="stickyNoteBody">
                {children}
            </div>
        </div>
    );
}